/**
 * Main content in our app is served under the #app-child-content div.
 * Which means window.scrollTo(0,0) won't work, as it's not the actual element being scrolled.
 */
export function scrollToTop() {
  const appContent = document.getElementById('app-child-content');
  if (appContent) {
    appContent.scrollTo({top: 0});
  }
}
